import routerOptions0 from "/Users/noah/Documents/websites/ghg-assessment-tool-landing-page/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}